
/** For sorting arrays, here are common sorting functions for general use */

export const alphaSort = (...args) => {
    if(!args.every(value => typeof value === 'string' || value instanceof String)) {
        console.error('Some values passed to alphaSort are not a string');
        return 0;
    }
    const [ a, b ] = args;
    const [ s1, s2 ] = [ a.toLowerCase(), b.toLowerCase() ];
    if (s1 > s2) return 1;
    if (s1 < s2) return -1;
    return 0;
};